import { render, staticRenderFns } from "./goMoney.vue?vue&type=template&id=b5c76684&scoped=true&"
import script from "./goMoney.vue?vue&type=script&lang=js&"
export * from "./goMoney.vue?vue&type=script&lang=js&"
import style0 from "./goMoney.vue?vue&type=style&index=0&lang=css&"
import style1 from "./goMoney.vue?vue&type=style&index=1&id=b5c76684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c76684",
  null
  
)

export default component.exports